<template>
  <div class="float-suggestions-search" v-if="show">
    <span class="text-muted d-block">{{user_data && user_data.main_group.name === 'creator' ? $t('creator.trending_platforms_campaging') : $t('creator.trending_platforms_suggestions')}}</span>
    <b-button pill
      size="sm"
      v-for="(net, index) in network" 
      :key="index" 
      :class="`${responsive_col ? 'w-100' : ''} mr-1 mt-1 btn-float-suggestions`"
      variant="btn-float-suggestions"
      @click="clickRedirection('network', net)"
    >
      <b-avatar class="align-items-center" size="24px">
        <b-img :src="getIconWhite(net)" :class="getIconColor(net, false)" fluid></b-img>
      </b-avatar>
      <span class="text-network">{{nameNetworks(net)}}</span>
    </b-button>
  </div>
</template>

<script>
import {
  BButton,
  BImg,
  BAvatar,
} from 'bootstrap-vue';
import { getIconWhite, getIconColor } from '@/libs/utils/icons';
import { nameNetworks } from '@/libs/utils/formats';
import { getUserData } from '@/libs/utils/user';


export default {
  name: 'suggestionsContainer',
  components: {
    BButton,
    BImg,
    BAvatar,
  },
  props: {
    show_suggestions: {
      type: Boolean,
      required: true,
      default: false
    },
    list_selected: {
      type: Object,
      required: false,
    },
    responsive_col: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      nameNetworks,
      getIconWhite,
      getIconColor,
      show: this.show_suggestions,
      network: ['tiktok', 'instagram','youtube','facebook','linkedin','twitch','twitter','spotify','pinterest','blog','snapchat'],
      user_data: getUserData(),
    }
  },
  methods: {
    clickRedirection(key_name, value) {
      if (Object.keys(this.list_selected).length > 0) {
        if (!this.user_data || (this.user_data.main_group.name !== 'creator')) {
          this.list_selected.list_button.push(value);
          this.list_selected.selected = true;
          this.list_selected.type_button = key_name; 
          this.$router.push({name: 'creadores', query: {[key_name]: value}});
          this.$root.$emit('update_proposals', this.list_selected);
        } else {
          this.list_selected.list_button.push(value);
          this.list_selected.selected = true;
          this.list_selected.type_button = key_name; 
          this.$router.push({name: 'marcas', query: {[key_name]: value}});
          this.$root.$emit('update_casting_calls', this.list_selected);
        }
      }
    },
    classButtonSelected(type) {
      if (Object.keys(this.list_selected).length > 0) {
        if (this.list_selected.selected) {
          return this.list_selected.list_button.find(value => value === type) ? 'btn-float-category-selected mr-1 mb-1' : 'btn-float-category mr-1 mb-1'
        } else {
          return 'btn-float-category mr-1 mb-1'
        }
      }
    }
  }
}
</script>
<style scoped>
.text-network {
  font-size: x-small;
  margin-left: 3px;
  font-family: 'avenir-medium';
}
.text-category {
  display: flex;
  font-size: x-small;
  font-family: 'avenir-medium';
}
.float-suggestions-search {
  width: 100%;
  height: auto;
  background-color: white;
  border-radius: 1em;
  padding: 1em;
  position: absolute;
  top: 4em;
  z-index: 100;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
}
.btn-float-suggestions {
  background-color: transparent !important;
  padding: 6px 12px 6px 2px;
  color: #444;
  margin-right: 6px !important;
  border-color: rgba(222,226,230,.7);
  cursor: pointer;
}
.btn-float-suggestions:hover {
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 14px 0px;
}
.btn-float-category-selected {
  background-color: #212529 !important;
  color: white;
  padding: 10px 14px;
}
.btn-float-category {
  background-color: rgba(222,226,230,.7) !important;
  padding: 10px 14px;
  color: #212529;
  cursor: pointer;
}
.btn-float-category:hover {
  background-color: #212529 !important;
  color: white;
  cursor: pointer;
}
.img-network-badge {
  width: 18px;
  height: 18px;
}
</style>